<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form ref="formRef" :model="form" label-width="auto" style="padding: 16px;" size="small" :rules="rules">
            <el-row style="width: 80%;">
                <el-col :span="12">
                    <el-form-item label="弹窗名称" prop="name">
                        <el-input v-model="form.name" />
                    </el-form-item>
                    <el-form-item label="开始时间" prop="begin_time">
                        <el-date-picker v-model="form.begin_time" type="datetime" placeholder="请选择开始时间"
                            format="YYYY-MM-DD HH:mm:ss(Z)" value-format="X" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="结束时间" prop="end_time">
                        <el-date-picker v-model="form.end_time" type="datetime" placeholder="请选择结束时间"
                            format="YYYY-MM-DD HH:mm:ss(Z)" value-format="X" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="弹窗位置" prop="location">
                        <el-input v-model="form.location" />
                    </el-form-item>
                    <el-form-item label="弹出机制">
                        <el-select v-model="form.window_type" placeholder="请选择弹出机制">
                            <el-option label="仅一次" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区域" prop="region">
                        <el-select v-model="form.region" placeholder="请选择区域">
                            <el-option label="中国" value="cn" />
                            <el-option label="美洲" value="us" />
                            <el-option label="欧洲" value="eu" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="规则" prop="rule_code">
                        <el-select v-model="form.rule_code" placeholder="请选择规则">
                            <el-option v-for="(item) in ruleList" :key="item.code" :label="item.name"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-form-item label="内容" style="font-weight: 700;"></el-form-item>
            <el-row v-for="(v, i) in form.contents" :key="i" style="margin-bottom: 8px;" :gutter="20">
                <el-col :span="7" style="display: flex;">
                    <el-row :gutter="10">
                        <el-col :span="4">
                            <div v-if="i === form.contents.length - 1" style="align-self: center;width: 64px;">
                                <span
                                    style="font-size: 24px; color: rgb(64, 158, 255); cursor: pointer;margin-right: 8px;align-self: center;"
                                    @click="addLanguage">
                                    <i class="el-icon-circle-plus" style="margin-left: 8px;"></i>
                                </span>
                                <span style="font-size: 24px; color: #f56c6c; cursor: pointer;align-self: center;"
                                    @click="subtractLanguage(i)" v-if="form.contents.length > 1">
                                    <i class="el-icon-remove"></i>
                                </span>
                            </div>
                            <div v-else
                                style="font-size: 24px; color: #f56c6c;cursor: pointer;align-self: center;width: 64px;text-align: right;"
                                @click="subtractLanguage(i)">
                                <i class="el-icon-remove" style="margin-left: 8px;"></i>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="语言" :rules="{
                                required: true,
                                message: '语言不能为空',
                                trigger: 'blur',
                            }">
                                <el-select v-model="v.language" placeholder="请选择语言">
                                    <el-option v-for="(item) in languageList" :key="item.code" :label="item.name"
                                        :value="item.code" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="内容" :prop="'contents.' + i + '.content'" :rules="{
                                required: true,
                                message: '内容不能为空',
                                trigger: 'blur',
                            }">
                                <el-button type="primary" size="small" style="height: 32px;"
                                    @click="configContent(v)">配置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="15">
                    <el-row :gutter="16" v-for="(btn, idx) in form.contents[i].buttons" :key="idx">
                        <el-col :span="7">
                            <el-form-item :label="`按钮${idx + 1}文案`" :prop="`contents.${i}.buttons.${idx}.name`" :rules="{
                                required: true,
                                message: '内容不能为空',
                                trigger: 'blur',
                            }">
                                <el-input v-model="btn.name" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="事件类型">
                                <el-select v-model="btn.event_type" placeholder="请选择事件类型">
                                    <el-option label="链接" :value="1" />
                                    <el-option label="关闭弹窗" :value="2" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="跳转类型" v-show="btn.event_type === 1">
                                <el-select v-model="btn.click_type" placeholder="请选择跳转类型">
                                    <el-option label="内部" :value="1" />
                                    <el-option label="外部" :value="2" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="链接" v-show="btn.event_type === 1">
                                <el-input v-model="btn.click_url" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="1">
                            <div v-if="idx === 0 && form.contents[i].buttons.length == 1"
                                style="align-self: center;width: 64px;">
                                <span
                                    style="font-size: 24px; color: rgb(64, 158, 255); cursor: pointer;margin-right: 8px;align-self: center;"
                                    @click="addButton(i)">
                                    <i class="el-icon-circle-plus" style="margin-left: 8px;"></i>
                                </span>
                            </div>
                            <div v-if="idx === 1"
                                style="font-size: 24px; color: #f56c6c;cursor: pointer;align-self: center;width: 64px;"
                                @click="subtractButton(i, idx)">
                                <i class="el-icon-remove" style="margin-left: 8px;"></i>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit(formRef)">确定</el-button>
            </el-form-item>
        </el-form>
        <el-drawer v-model="drawer" :title="`配置${currentConfigContent.language}内容`" direction="rtl" size="40%"
            :close-on-click-modal="true">
            <div style="padding: 0px 20px 0px 16px;">
                <!-- <editor ref="editorone" style="z-index:990;width:650px;" @change="editorchange"
                    :value="drawerForm.detail">
                </editor> -->
                <el-input v-model="drawerForm.detail" :rows="30" type="textarea" />
                <div class="drawer_footer" style="padding-top: 10px;">
                    <el-button size="small" @click="drawer = false">取消</el-button>
                    <el-button type="primary" size="small" @click="saveDrawer">确定</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { reactive, onMounted, ref, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import Editor from "../../../../components/richtext/index.vue"
import api from '../../../../axios/api'
import { convertDateToTimestamp } from '../../../../util/util'

export default {
    components: {
        Editor
    },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const form = reactive({
            name: '',
            begin_time: '',
            end_time: '',
            location: '',
            window_type: 1,
            rule_code: '',
            region: '',
            contents: [
                {
                    language: 'en',
                    content: '',
                    buttons: [{ name: '', event_type: 1, click_url: '', click_type: 1 }, { name: '', event_type: 2, click_url: '', click_type: 2 }]
                }
            ]
        })
        const formRef = ref()
        const drawerForm = reactive({
            detail: ''
        })
        const languageList = ref([])
        const drawer = ref(false)
        const currentConfigContent = ref({})
        const rules = reactive({
            name: [
                { required: true, message: '弹窗名称不能为空', trigger: 'blur' }
            ],
            location: [
                { required: true, message: '弹窗位置不能为空', trigger: 'blur' }
            ],
            begin_time: [
                {
                    required: true, validator: (r, v, cb) => {
                        if (form.end_time && convertDateToTimestamp(v) > convertDateToTimestamp(form.end_time)) {
                            cb(new Error('开始时间不能大于结束时间'))
                        } else {
                            if (!form.begin_time) {
                                cb(new Error('请选择开始时间'))
                            } else {
                                cb()
                            }
                        }
                    }, trigger: 'blur'
                }
            ],
            end_time: [
                {
                    required: true, validator: (r, v, cb) => {
                        if (form.begin_time && convertDateToTimestamp(v) < convertDateToTimestamp(form.begin_time)) {
                            cb(new Error('结束时间不能小于开始时间'))
                        } else {
                            if (!form.end_time) {
                                cb(new Error('请选择结束时间'))
                            } else {
                                cb()
                            }
                        }
                    }, trigger: 'blur'
                }
            ],
            rule_code: [
                { required: true, message: '请选择规则', trigger: 'change' }
            ],
            region: [
                { required: true, message: '请选择区域', trigger: 'change' }
            ],
            contents: [
                {
                    required: true, validator: (r, v, cb) => {
                        let isValid = 0
                        for (let i = 0; i < v.length; i++) {
                            const e = v[i]
                            if (!e.language) {
                                isValid = 1
                                break
                            }
                            if (e.buttons?.length > 0) {
                                for (let j = 0; j < e.buttons.length; j++) {
                                    const b = e.buttons[j]
                                    if (!b.name) {
                                        isValid = 1
                                        break
                                    }
                                }
                            }
                        }
                        if (isValid === 1) {
                            cb(new Error("不能为空"))
                        } else {
                            cb()
                        }
                    }, trigger: 'blur'
                }
            ]
        })
        const ruleList = ref([])

        // 获取语言列表
        const getLanguageList = async () => {
            const res = await api.LanguageList({
                page: 1,
                limit: 500
            })
            if (res.data.code == 200) {
                languageList.value = res.data.data.data
                return
            }
        }

        // 获取规则列表
        const getContentManageRuleList = async () => {
            const res = await api.ContentManageRuleList({ page: 1, limit: 500 })
            if (res.data.code === 200) {
                const { list } = res.data.data
                ruleList.value = list
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const addLanguage = () => {
            form.contents.push({
                language: 'en',
                content: '',
                buttons: [{ name: '', event_type: 1, click_url: '', click_type: 1 }, { name: '', event_type: 2, click_url: '', click_type: 2 }]
            })
        }

        const subtractLanguage = (i) => {
            form.contents.splice(i, 1)
        }

        const onSubmit = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    const toRawForm = JSON.parse(JSON.stringify(toRaw(form)))
                    toRawForm.begin_time = convertDateToTimestamp(toRawForm.begin_time)
                    toRawForm.end_time = convertDateToTimestamp(toRawForm.end_time)
                    toRawForm.contents.map(v => {
                        v.buttons = JSON.stringify(v.buttons)
                    })
                    console.log('toRawForm --> ', toRawForm)
                    const res = await api.ContentManagePopupAdd(toRawForm)
                    if (res.data.code == 200) {
                        ElMessage.success('成功')
                        router.go(-1)
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const goback = () => {
            router.go(-1)
        }

        const editorchange = (content) => {
            drawerForm.detail = content
        }

        const configContent = (item) => {
            drawer.value = true
            currentConfigContent.value = item
            drawerForm.detail = item.content
        }

        const addButton = (i) => {
            form.contents[i].buttons.push({ name: '', event_type: 2, click_url: '', click_type: 2 })
        }

        const subtractButton = (i, idx) => {
            if (form.contents[i].buttons.length > 1) {
                form.contents[i].buttons.splice(idx, 1)
            } else {
                ElMessage.warning('至少保留一个按钮')
            }
        }

        const saveDrawer = () => {
            if (drawerForm.detail.trim() === '') {
                ElMessage.warning('内容不能为空')
                return
            }
            form.contents.forEach(language => {
                if (language.language === currentConfigContent.value.language) {
                    language.content = drawerForm.detail
                }
            })
            drawer.value = false
        }

        onMounted(() => {
            getLanguageList()
            getContentManageRuleList()
            const code = route.params.code
            if (code && code !== '0') {
                api.ContentManagePopupDetail({ code }).then(res => {
                    if (res.data.code === 200) {
                        Object.assign(form, res.data.data)
                        form.begin_time = res.data.data.begin_time * 1000
                        form.end_time = res.data.data.end_time * 1000
                        form.contents.map(v => {
                            v.buttons = JSON.parse(v.buttons)
                        })
                    } else {
                        ElMessage.error('获取详情失败: ' + res.data.msg)
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err)
                    ElMessage.error('获取详情失败')
                })
            }
        })

        return {
            form,
            addLanguage,
            subtractLanguage,
            onSubmit,
            goback,
            languageList,
            drawer,
            drawerForm,
            currentConfigContent,
            configContent,
            editorchange,
            addButton,
            subtractButton,
            saveDrawer,
            rules,
            formRef,
            ruleList,
            getContentManageRuleList
        }
    }
}
</script>

<style scoped language="stylus" rel="stylesheet/stylus">
.container {
    .el-upload-list__item-thumbnail {
        width: 80px;
        height: 40px;
        object-fit: contain;
        display: block;
    }

    .el-upload-list__item-actions {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s;
    }

    .el-upload-list__item-actions:hover {
        opacity: 1;
    }

    .el-upload-list__item-actions:hover span {
        display: inline-flex;
    }

    .el-upload-list__item-actions span {
        display: none;
        cursor: pointer;
    }

    .el-upload-list__item-actions:hover span {
        display: inline-flex;
    }

    .el-upload-list__item-actions .el-upload-list__item-delete {
        position: static;
        font-size: inherit;
        color: inherit;
    }

    .el-upload-list__item-actions span+span {
        margin-left: 16px;
    }

    .el-upload-list__item-delete {
        position: absolute;
        right: 10px;
        top: 0;
        font-size: 12px;
        color: '#606266';
        display: none;
    }

    ::v-deep(.el-upload-list__item:first-child) {
        margin-top: 0;
    }

    ::v-deep(.el-upload-list) {
        margin-left: 10px;
    }
}
</style>